var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreedot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 20,
    viewBox: "0 0 6 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49609 5C4.87681 5 5.99609 3.88071 5.99609 2.5C5.99609 1.11929 4.87681 0 3.49609 0C2.11538 0 0.996094 1.11929 0.996094 2.5C0.996094 3.88071 2.11538 5 3.49609 5Z",
    fill: "#1C4784"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49609 12C4.87681 12 5.99609 10.8807 5.99609 9.5C5.99609 8.11929 4.87681 7 3.49609 7C2.11538 7 0.996094 8.11929 0.996094 9.5C0.996094 10.8807 2.11538 12 3.49609 12Z",
    fill: "#1C4784"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49609 20C4.87681 20 5.99609 18.8807 5.99609 17.5C5.99609 16.1193 4.87681 15 3.49609 15C2.11538 15 0.996094 16.1193 0.996094 17.5C0.996094 18.8807 2.11538 20 3.49609 20Z",
    fill: "#1C4784"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedot);
export default __webpack_public_path__ + "static/media/threedot.f5c4adf1ecb05d6742cbe56769d72912.svg";
export { ForwardRef as ReactComponent };